import { useTheme, useMediaQuery } from 'components/ui';

const useMobile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  return isMobile;
};

export default useMobile;
